import { useEffect } from "react";
import "./awb-form.css";
import { useTranslation } from "react-i18next";

function AwbForm({ register, setValue, watch }) {
  const [tHome] = useTranslation("homePage");
  const prefixValue = watch("prefix");
  const nguideValue = watch("waybillNumber");

  useEffect(() => {
    if(prefixValue) {
      const onlyNumbers = prefixValue.replace(/\D/g, '');
      if (prefixValue !== onlyNumbers) {
        setValue("prefix", onlyNumbers);
      }
    }

    if(nguideValue) {
      const onlyNumbers = nguideValue.replace(/\D/g, '');
      if (nguideValue !== onlyNumbers) {
        setValue("waybillNumber", onlyNumbers);
      }
    }
  }, [prefixValue, setValue, nguideValue])

  return (
    <>
      <div className="awb-form-home">

        <div className="input-container-awb">
          <div className="input-text">
            <label><p>{tHome("track-guide-form.prefix-label")}</p></label>
            <input 
              id="prefix" 
              type="text" 
              defaultValue={"139"}
              maxLength={"3"}
              {...register("prefix", {
                required: true,
                maxLength: 3,
                minLength: 3,
                pattern: {
                  value: /^[0-9]*$/,
                  message: 'Solo se permiten números'
                }
              })} 
            />
          </div>

          <div className="input-text">
            <label><p>{tHome("track-guide-form.waybill-number-label")}</p></label>
            <input 
              id="waybillNumber" 
              type="text" 
              defaultValue={""} 
              maxLength={"8"}
              {...register("waybillNumber", {
                required: false, 
                maxLength: 8,
                minLength: 8, 
                pattern: {
                  value: /^[0-9]*$/,
                  message: 'Solo se permiten números'
                } 
              })} 
            />
          </div>
        </div>

      </div>
    </>
  )
}

export default AwbForm;